module.exports = __webpack_public_path__ + "static/00023.910c447c.jpg";